import "core-js/modules/es.array.join";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.string.split";
export var commaSeparate = function commaSeparate() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var maxDisplayCount = arguments.length > 1 ? arguments[1] : undefined;
  var items = string.split(', ');
  var truncatedItems = items.slice(0, maxDisplayCount);
  var truncatedItemsString = truncatedItems.join(', ');

  if (items.length > maxDisplayCount) {
    return "".concat(truncatedItemsString, ", \u2026");
  }

  return truncatedItemsString;
};